export default {
  headerContent: {
    title: 'Türk Nippon İkinci El Araç Garanti Sigortası Fiyatları',
    slogan: "2. El Araç Garanti Sigortası 'nı işin uzmanına bırak.",
    btnTitle: '2. EL ARAÇ GARANTİ SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türk Nippon Sigorta 2. El Araç Garanti Sigortası',
    description: {
      title: 'Türk Nippon Sigorta 2. El Araç Garanti Sigortası Nedir? ',
      content: [
        '2. El Garanti Sigortası satmış veya almış olduğunuz araçta oluşabilecek arızalar karşısında sizi güvence altına alan sigorta ürünüdür.',
        'İkinci El Garanti Sigortası galerilerin satışını yaptığı ürünlerin garanti zorunluluğunu kapsar.'
      ]
    },
    subContent: {
      title: 'Türk Nippon Sigorta 2. El Araç Garanti Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            'Türk Nippon Sigorta 2. El Araç Garanti Sigortası Teminatları kapsamında; ',
          subList: [
            'Motor Teminatı',
            'Diferansiyel ve Şaft Teminatı',
            'Şanzıman Teminatı',
            'Elektrik Teminatı',
            'Yağ Sızdırmazlık ve Contalar Teminatı',
            'Ana ünite kaplamaları teminatı olarak sunmaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Sigorta 2. El Araç Garanti Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Sigorta 2. El Araç Garanti Sigortası ',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Sigorta 2. El Araç Garanti Sigortası ',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Sigorta 2. El Araç Garanti Sigortası ',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Sigorta 2. El Araç Garanti Sigortası ',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türk Nippon  Sigorta Ferdi Kaza Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
